import script from "./InsufficientCreditsModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./InsufficientCreditsModal.vue?vue&type=script&lang=ts&setup=true"

import "./InsufficientCreditsModal.vue?vue&type=style&index=0&id=7dc60cd3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dc60cd3"]])

export default __exports__